module.exports = __webpack_public_path__ + "static/media/egg_haibao_canjia.eb5821a7.png";